import React, { useState, useEffect, useRef } from 'react';
import { get, post, put, destroy } from '../services/apiController';
import { TABLE_DEFAULT_LIMIT, DEBOUNCE_DELAY } from '../util/constant';
import { Table, Modal, Button, Form, FloatingLabel, Row, Col, Tabs } from 'react-bootstrap';
import { toast, ToastContainer } from 'react-toastify';
import { DeleteIcon, EditIcon } from './icons';
import { Link } from 'react-router-dom';
import 'react-toastify/dist/ReactToastify.css';
import AlertIcon from '../../src/img.svg';
import PaginationInPage from './Pagination';
import useDebounce from './useDebounce';
import { GrDocumentExcel } from 'react-icons/gr';
import Breadcrumb from '../components/Breadcrumb';

const CollectionCenter = () => {
  const formFields = { name: '', companyId: '' };
  const [totalRecords, setTotalRecords] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [collectionCenterForm, setCollectionCenterForm] = useState(formFields);
  const [showConfirmModel, setShowConfirmModel] = useState(false);
  // const [idToDeleted, setIdToDeleted] = useState("");
  // const [deleteModel, setDeleteModel] = useState(false)
  const [CollectionCenterList, setCollectionCentenList] = useState([]);
  const [companyList, setCompanyList] = useState([]);
  const [query, setQuery] = useState('');
  const clickToDownload = useRef(null);

  const handleShow = () => {
    setShowConfirmModel(true);
    setCollectionCenterForm(formFields);
  };

  const handleClose = () => {
    setShowConfirmModel(false);
  };

  const handleChange = (event) => {
    event.preventDefault();
    let name = event.target.name;
    let value = event.target.value;
    setCollectionCenterForm({ ...collectionCenterForm, [name]: value });
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    if ('id' in collectionCenterForm) {
      // try {
      //   await put(collectionCenterForm, '/collection-centers/' + collectionCenterForm.id)
      //   toast.success("Collection Center updated successfully");
      //   setShowConfirmModel(false);
      //   getCollectionCenter();
      // } catch (err) {
      //   toast.error(err.message, { autoClose: 3000 });
      // }
    } else {
      try {
        await post(collectionCenterForm, '/collection-centers/');
        toast.success('Collection Center created successfully');
        setShowConfirmModel(false);
        getCollectionCenter();
      } catch (err) {
        toast.error(err?.response?.data?.message || err?.response?.data?.data?.message || err.message, { autoClose: 2000 });
      }
    }
  };

  function getCollectionCenter() {
    try {
      get(`/collection-centers/?page=${currentPage}&limit=${TABLE_DEFAULT_LIMIT}&query=${query}`).then((response) => {
        setCollectionCentenList(response.data.rows);
        setTotalRecords(response.data.count);
      });
    } catch (err) {
      toast.error(err.response.data.data.message);
    }
  }

  function getCompanies() {
    try {
      get(`/companies`).then((response) => {
        setCompanyList(response.data.rows);
      });
    } catch (err) {
      toast.error(err.response.data.data.message);
    }
  }

  function excelReport() {
    try {
      get(`/collection-centers/?conditionType=download`).then((response) => {
        clickToDownload.current.href = `${process.env.REACT_APP_BASE_URL}/file/download?filePath=${response.data.filePath}`;
        setTimeout(() => {
          clickToDownload.current.click();
        }, 500);
      });
    } catch (err) {
      toast.error(err.response.data.data.message);
    }
  }

  useDebounce(
    () => {
      if (currentPage !== 1) {
        setCurrentPage(1);
      } else {
        getCollectionCenter();
      }
    },
    [query],
    DEBOUNCE_DELAY
  );

  useEffect(() => {
    getCompanies();
  }, []);

  useEffect(() => {
    getCollectionCenter();
  }, [currentPage]);

  return (
    <React.Fragment>
      <ToastContainer />
      <Breadcrumb
        navigation={[
          { link: '#', title: 'Store Operations' },
          { link: '#', title: 'Cash Collection' },
          { link: '#', title: 'Master' },
          { link: '#', title: 'Collection Centers' },
        ]}
      />
      <div className="card">
        <div className="card-header white-color" style={{ padding: '1rem 1.7rem' }}>
          <h4 className="card-title mb-0" style={{ fontSize: '16px' }}>
            Collection Centers | {totalRecords ?? 0}
          </h4>
          <div className="card-header-actions">
            <Form.Control
              value={query}
              onChange={(e) => setQuery(e.target.value)}
              type="search"
              placeholder="Search by collection center"
              style={{ width: '250px', marginRight: '20px' }}
            />
            <GrDocumentExcel title="Download collection centers" className="react-icons green" onClick={excelReport} />
            <a ref={clickToDownload} href="" target="_blank" className="hiddenItem">
              HiddenClick
            </a>
            <button type="button" className="btn app-btn-default dark-color" onClick={handleShow}>
              Add Collection Center
            </button>
          </div>
        </div>
        <div className="card-body px-0 vehicle-requests-table pt-0 pb-0">
          <div className="row">
            <div className="col">
              <Table responsive striped bordered>
                <thead>
                  <tr>
                    <th>#</th>
                    <th>Collection Center</th>
                    <th>Locations</th>
                    <th>Company</th>
                  </tr>
                </thead>
                <tbody>
                  {CollectionCenterList.map((item, index) => {
                    return (
                      <React.Fragment key={item?.id}>
                        <tr>
                          {item?.Branches.length > 0 ? (
                            <>
                              <td style={{ verticalAlign: 'middle' }} rowSpan={item?.Branches.length}>
                                {(currentPage - 1) * TABLE_DEFAULT_LIMIT + (index + 1)}
                              </td>
                              <td style={{ verticalAlign: 'middle' }} rowSpan={item?.Branches.length}>
                                {item?.name}
                              </td>
                              <td>{item?.Branches[0]?.name}</td>
                              <td style={{ verticalAlign: 'middle' }} rowSpan={item?.Branches.length}>
                                {item?.Company?.name}
                              </td>
                            </>
                          ) : (
                            <>
                              <td>{(currentPage - 1) * TABLE_DEFAULT_LIMIT + (index + 1)}</td>
                              <td>{item?.name}</td>
                              <td>No Locations found</td>
                              <td>{item?.Company?.name}</td>
                            </>
                          )}
                        </tr>
                        {item?.Branches?.length > 1 &&
                          item?.Branches.slice(1).map((branch, index) => {
                            return (
                              <tr key={index}>
                                <td className="px-2">{branch?.name}</td>
                              </tr>
                            );
                          })}
                      </React.Fragment>
                    );
                  })}
                </tbody>
              </Table>
              <PaginationInPage
                currentPage={currentPage}
                setCurrentPage={setCurrentPage}
                totalRecords={totalRecords}
                TABLE_DEFAULT_LIMIT={TABLE_DEFAULT_LIMIT}
              />
            </div>
          </div>
        </div>
      </div>
      <Modal size="lg" show={showConfirmModel} backdrop="static" keyboard={false} className="request-modal">
        <Modal.Header>
          <Modal.Title>{'id' in collectionCenterForm ? 'Edit Collection Center' : 'Add Collection Center'}</Modal.Title>
          <button type="button" className="btn-close" aria-label="Close" onClick={handleClose}></button>
        </Modal.Header>
        <Modal.Body>
          <Form autoComplete="off" onSubmit={handleSubmit}>
            <Row>
              <Col xs={6}>
                <FloatingLabel controlId="floatingInput" label="Collection Center Name" className="mb-3">
                  <Form.Control
                    className="input"
                    name="name"
                    value={collectionCenterForm.name}
                    onChange={handleChange}
                    type="text"
                    placeholder="Collection Center Name"
                    required
                  />
                </FloatingLabel>
              </Col>
              <Col xs={6}>
                <FloatingLabel controlId="floatingInput" label="Company" className="mb-3">
                  <Form.Select
                    className="input"
                    value={collectionCenterForm.companyId}
                    name="companyId"
                    onChange={handleChange}
                    placeholder="Company Id"
                    required
                  >
                    <option>Select Company</option>
                    {companyList.map((company) => (
                      <option key={company.id} id={company.id} value={company.id}>
                        {company.name}
                      </option>
                    ))}
                  </Form.Select>
                </FloatingLabel>
              </Col>
            </Row>
            <div className="container text-center">
              <Button type="submit" className="add-request-btn mt-4 mb-3">
                {'id' in collectionCenterForm ? 'Update' : 'Add'}
              </Button>
            </div>
          </Form>
        </Modal.Body>
      </Modal>
    </React.Fragment>
  );
};

export default CollectionCenter;
